export default __webpack_public_path__ + "static/media/WeekCardPalace1.d5e0e12b.jpg";